import React, { useState } from 'react';
import { PUBLIC_PATH } from '../../../../../shared/config/routes-config';
import Button, {
  ButtonSize,
  ButtonType
} from '../../../../../shared/components/core-ui/button/button.component';
import { trackEvent } from '../../../../../shared/services/utils/tracking/tracking.service';
import useWindowResizer from '../../../../../shared/hooks/window-resizer/window-resizer.hook';
import { ConfirmModal } from '../../components/confirm-modal/confirm-modal.component';
import EdiText from 'react-editext';

export interface PartnerInfoProps {
  data: {
    partnerName: string;
    partnerId: string;
    partnerEmail: string;
    partnerPhone: string;
    propertyId: string;
    partnerShare: number;
  };
  eventHandlers: {
    addPartner: () => void;
    updatePartnerShare: (share: number) => void;
    deletePartner: () => void;
  };
}
export const PartnerInfo: React.FC<PartnerInfoProps> = ({ data, eventHandlers }) => {
  const isMobileView = useWindowResizer();
  const [disabledActions, setDisabledActions] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState<boolean>(false);

  return (
    <div className="flex-1 mt-4 pb-8 rounded-lg bg-white shadow-md p-6 w-full">
      {data.partnerId ? (
        <>
          <div className="font-bold text-[#566346] text-[1.6rem] mb-4">Partner Info</div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="flex flex-col">
              <span className="text-base uppercase text-gray-500 font-medium">Name :</span>
              <span className="text-gray-800 font-medium">{data.partnerName}</span>
            </div>
            <div className="flex flex-col">
              <span className="text-base uppercase text-gray-500 font-medium">Email :</span>
              <span className="text-gray-800 font-medium">{data.partnerEmail}</span>
            </div>
            <div className="flex flex-col">
              <span className="text-base uppercase text-gray-500 font-medium">Phone :</span>
              <span className="text-gray-800 font-medium">{data.partnerPhone}</span>
            </div>
            <div className="flex justify-start w-full mb-5 pr-1 items-center md:w-1/2" />
            <div className="flex justify-start w-full gap-3 mb-5 pr-1 items-center">
              <span className="text-base uppercase min-w-fit   text-gray-500 font-medium">
                Partner Share :
              </span>
              <EdiText
                className="min-w-[150px]"
                type="text"
                onEditingStart={() => {
                  setDisabledActions(true);
                }}
                onCancel={() => {
                  setDisabledActions(false);
                }}
                value={data.partnerShare + '%'}
                onSave={(val: string) => {
                  setDisabledActions(false);
                  eventHandlers.updatePartnerShare(Number(val.replace('%', '')));
                }}
              />
            </div>
          </div>

          <div className="justify-end gap-3 flex mt-6 ml-6">
            <Button
              onClick={() => {
                eventHandlers.addPartner();
              }}
              tracking={{
                action: 'cancel',
                category: '',
                label: ''
              }}
              size={isMobileView ? ButtonSize.full : ButtonSize.medium}
              disabled={data.propertyId === '' || disabledActions}
            >
              Update Partner
            </Button>

            <Button
              onClick={() => {
                setShowDeleteModal(true);
              }}
              tracking={{
                action: 'open',
                category: 'blocked-date',
                label: 'add-blocked-date-modal'
              }}
              type={ButtonType.primaryInverted}
              size={ButtonSize.medium}
              disabled={disabledActions}
            >
              Delete Partner
            </Button>
          </div>
        </>
      ) : (
        <div>
          <img
            src={`${PUBLIC_PATH}/assets/jpeg/partner.jpeg`}
            alt="assign Partner"
            className="block mx-auto rounded-[25px] w-[200px] mb-8"
          />

          <Button
            onClick={() => {
              eventHandlers.addPartner();
              trackEvent('add', {
                category: '',
                label: ''
              });
            }}
            tracking={{
              action: 'cancel',
              category: '',
              label: ''
            }}
            size={isMobileView ? ButtonSize.full : ButtonSize.medium}
            disabled={data.propertyId === '' || disabledActions}
          >
            Assign Partner
          </Button>
          {data.propertyId === '' && (
            <span className="text-[#dda22c] m-8 flex items-center justify-center">
              you can't assign a Partner to a unit that doesn't have property
            </span>
          )}
        </div>
      )}

      <ConfirmModal
        config={{
          showModal: showDeleteModal,
          message: 'Are you sure you want to delete this Partner?'
        }}
        eventHandlers={{
          denyAction: () => {
            setShowDeleteModal(false);
          },
          confirmAction: () => {
            setShowDeleteModal(false);
            eventHandlers.deletePartner();
          }
        }}
      />
    </div>
  );
};
